import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '../store/user'

const routes = [
  { path: '/login', component: () => import('../views/Login.vue') },
  {
    path: '/',
    component: () => import('../layout/AdminLayout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: () => import('../views/Dashboard.vue') },
      { path: 'workbench', component: () => import('../views/Workbench.vue') },
      { path: 'orders', component: () => import('../views/Orders.vue') },
      { path: 'intake', component: () => import('../views/Intake.vue') },
      { path: 'pickup-clothes', component: () => import('../views/Pickup.vue') },
      { path: 'products', component: () => import('../views/Products.vue') },
      { path: 'stores', component: () => import('../views/Stores.vue') },
      { path: 'store-accounts', component: () => import('../views/StoreAccounts.vue') },
      { path: 'members', component: () => import('../views/Members.vue') },
      { path: 'member-card', component: () => import('../views/MemberCard.vue') },
      { path: 'member-recharge', component: () => import('../views/MemberRecharge.vue') },
      { path: 'marketing', component: () => import('../views/Marketing.vue') },
      { path: 'channels', component: () => import('../views/Channels.vue') },
      { path: 'finance', component: () => import('../views/Finance.vue') },
      { path: 'settings', component: () => import('../views/Settings.vue') },
      { path: 'settings-pay', component: () => import('../views/SettingsPay.vue') },
      { path: 'settings-points', component: () => import('../views/SettingsPoints.vue') },
      { path: 'settings-message', component: () => import('../views/SettingsMessage.vue') },
      { path: 'settings-help', component: () => import('../views/SettingsHelp.vue') },
      { path: 'settings-precheck', component: () => import('../views/SettingsPrecheck.vue') },
      { path: 'settings-print', component: () => import('../views/SettingsPrint.vue') },
      { path: 'settings-shelf', component: () => import('../views/SettingsShelf.vue') },
      { path: 'factories', component: () => import('../views/Factories.vue') },
      { path: 'logistics', component: () => import('../views/LogisticsAdmin.vue') },
      { path: 'express-center', component: () => import('../views/ExpressCenter.vue') },
      { path: 'factory-accounts', component: () => import('../views/FactoryAccounts.vue') },
      { path: 'staff-accounts', component: () => import('../views/StaffAccounts.vue') },
      { path: 'store-value', component: () => import('../views/StoreValue.vue') },
      { path: 'store-config', component: () => import('../views/StoreConfig.vue') }
    ]
  }
]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach(async (to) => {
  const user = useUserStore()
  if (to.query.token) {
    const token = String(to.query.token)
    user.token = token
    localStorage.setItem('xk_token', token)
  }
  if (to.query.noprint === '1' || to.query.from === 'miniapp') {
    localStorage.setItem('xk_noprint', '1')
    document.body.classList.add('miniapp-mobile')
  }
  if (to.path === '/login') return true
  if (!user.token) return '/login'
  if (!user.menus.length) {
    try { await user.refresh() } catch { return '/login' }
  } else if (user.role === 'FACTORY' && user.user && user.user.isParent == null) {
    try { await user.refresh() } catch { return '/login' }
  }
  user.ensureStoreOrders()
  const superPages = ['/factories', '/factory-accounts', '/logistics']
  const storeManaged = to.path === '/store-accounts' && user.menus.some(m => m.path === '/stores')
  const memberManaged = ['/member-card', '/member-recharge'].includes(to.path) && user.menus.some(m => m.path === '/members')
  const settingsManaged = to.path.startsWith('/settings') && user.menus.some(m => m.path === '/settings')
  const expressCenter = to.path === '/express-center' && user.role === 'FACTORY' && user.user?.isParent
  if (user.role === 'SUPER' && !user.factoryId && !superPages.includes(to.path)) return '/factories'
  const allowed = user.menus.some(m => m.path === to.path) || (user.role === 'SUPER' && superPages.includes(to.path)) || storeManaged || memberManaged || settingsManaged || expressCenter
  if (!allowed) return user.menus[0]?.path || '/login'
  return true
})

export default router
